import { StoreEnhancer } from "@reduxjs/toolkit";
import { Reducer } from "react";
import { RESET_STATE_ACTION_TYPE } from "./constants";

/**
 * Store enhancer для redux, позволяющий сбросить состояние при передаче определённого action
 *
 * @example
 * export const store = configureStore({
 *  reducer: rootReducer,
 *  enhancers: [resetStateEnhancer]
 * });
 */

export const resetStateEnhancer: StoreEnhancer =
  (createStore) => (reducer, initialState) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enhancedReducer: Reducer<any, any> = (state, action) => {
      if (action.type === RESET_STATE_ACTION_TYPE) {
        return reducer(undefined, action);
      }

      return reducer(state, action);
    };

    return createStore(enhancedReducer, initialState);
  };
